import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import login from '../views/login.vue'
import neworder from '../views/neworder.vue'
import Branch from '../views/master/Branch.vue'
import Products from '../views/master/products.vue'
import services from '../views/master/services.vue'
import cost from '../views/master/cost.vue'
import orderlist from '../views/orderlist.vue'
import orderDetails from '../views/orderDetails.vue'
import customerlist from '../views/customerlist.vue'
import customerDetails from '../views/customerDetails.vue'
import user from '../views/master/user.vue'
import profile from '../views/profile.vue'
import report from '../views/report.vue'
import accounting from '../views/accounting.vue'
import singleaccounting from '../views/singleaccounting.vue'
import allorderlist from '../views/allorderlist.vue'
import accountinghistory from '../views/accountinghistory.vue'
import register from '../views/register.vue'
import registerlaundry from '../views/registerlaundry.vue'
import daywisereport from '../views/daywisereport.vue'
import deliverylist from '../views/deliverylist.vue'
import deliveryreport from '../views/deliveryreport.vue'
import custlogin from '../views/custfront/custlogin.vue'
import custbooking from '../views/custfront/custbooking.vue'
import onlineorder from '../views/master/onlineorder.vue'
import onlineorderlist from '../views/custfront/onlineorderlist.vue'
import onlineorderdetails from '../views/custfront/onlineorderdetails.vue'









const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  
   {
    path: '/orderDetails',
    name: 'orderDetails',
    component: orderDetails
  },
  
 {
    path: '/branch',
    name: 'Branch',
    component: Branch
  },
  {
    path: '/Products',
    name: 'Products',
    component: Products
  },
  {
    path: '/services',
    name: 'services',
    component: services
  },


  {
    path: '/cost',
    name: 'cost',
    component: cost
  },

  
  {
    path: '/',
    name: 'login',
    component: login
  },


  {
    path: '/neworder',
    name: 'neworder',
    component: neworder
  },


  {
    path: '/orderlist',
    name: 'orderlist',
    component: orderlist
  },


  {
    path: '/customerlist',
    name: 'customerlist',
    component: customerlist
  },

  {
    path: '/customerDetails',
    name: 'customerDetails',
    component: customerDetails
  },

  {
    path: '/user',
    name: 'user',
    component: user
  },

  {
    path: '/profile',
    name: 'profile',
    component: profile
  },

  {
    path: '/report',
    name: 'report',
    component: report
  },

  {
    path: '/accounting',
    name: 'accounting',
    component: accounting
  },


  {
    path: '/singleaccounting',
    name: 'singleaccounting',
    component: singleaccounting
  },


  {
    path: '/allorderlist',
    name: 'allorderlist',
    component: allorderlist
  },
  {
    path: '/accountinghistory',
    name: 'accountinghistory',
    component: accountinghistory
  },

  {
    path: '/register',
    name: 'register',
    component: register
  },

  {
    path: '/registerlaundry',
    name: 'registerlaundry',
    component: registerlaundry
  },

  {
    path: '/daywisereport',
    name: 'daywisereport',
    component: daywisereport
  },

  {
    path: '/deliverylist',
    name: 'deliverylist',
    component: deliverylist
  },
   {
    path: '/deliveryreport',
    name: 'deliveryreport',
    component: deliveryreport
  },

    {
    path: '/custlogin',
    name: 'custlogin',
    component: custlogin
  },

    {
    path: '/custbooking',
    name: 'custbooking',
    component: custbooking
  },

    {
    path: '/onlineorder',
    name: 'onlineorder',
    component: onlineorder
  },

      {
      path: '/onlineorderlist',
      name: 'onlineorderlist',
      component: onlineorderlist
    },
       {
      path: '/onlineorderdetails',
      name: 'onlineorderdetails',
      component: onlineorderdetails
    },




  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]
// Update the document title dynamically

const router = createRouter({
    
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
